import React from 'react';
import styles from './css/ElectricityPowerGrid.module.css';
import { formatNumberWithCommas } from '@/utils/numbers';

interface PowerGridProps {
    gridItems: {
        value: number;
        unit: string;
        description: string;
    }[];
}

interface GridItemProps {
    value: number;
    unit: string;
    description: string;
}

const GridItem = ({ value, unit, description }: GridItemProps) => (
    <div className={styles.gridItem}>
        <div className={styles.headingContainer}>
            <h1 className={styles.unit}>{unit}</h1>
            <h1 className={styles.heading}>{formatNumberWithCommas(value) || 0}</h1>
        </div>
        <p className={styles.description}>{description}</p>
    </div>
);

export const ElectricityPowerGrid: React.FC<PowerGridProps> = ({ gridItems }) => {
    return (
        <div className={styles.gridContainer}>
            {gridItems.map((item, index) => (
                <GridItem key={index} {...item} />
            ))}
        </div>
    );
};